import { render, staticRenderFns } from "./ChoicePage.vue?vue&type=template&id=5f0e4670&scoped=true"
import script from "./ChoicePage.vue?vue&type=script&lang=js"
export * from "./ChoicePage.vue?vue&type=script&lang=js"
import style0 from "./ChoicePage.vue?vue&type=style&index=0&id=5f0e4670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e4670",
  null
  
)

export default component.exports